import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import filter from 'lodash/filter';

import { FetchProjectMembersQueryResponse } from '../../../../main/projectMembers/queries/projectMembers.query';
import { FetchTaskMembersQueryResponse } from '../../../../main/taskMembers/queries/taskMembers.query';

import { MentionsPluginAllValues } from '../../components/ProjectTeamMentionsPlugin';

type GetMentionIdsOption = {
  mentionNodeIds?: string[];
  taskMembers?: FetchTaskMembersQueryResponse[];
  projectMembers?: FetchProjectMembersQueryResponse[];
};

function getMentionIds({
  mentionNodeIds,
  projectMembers,
  taskMembers
}: GetMentionIdsOption): string[] | undefined {
  const mentionIds = [];

  if (isEmpty(mentionNodeIds)) {
    return undefined;
  }

  for (const id of mentionNodeIds) {
    if (id === MentionsPluginAllValues.ALL_PROJECT_MEMBERS) {
      const projectMembersId = map(
        filter(projectMembers, (member) => !member?.user?.blocked),
        'user.id'
      );

      mentionIds.push(...projectMembersId);
      continue;
    }

    if (id === MentionsPluginAllValues.ALL_PROJECT_PERFORMERS) {
      const projectPerformersId = map(
        filter(
          projectMembers,
          (member) => !member?.user?.blocked && !member?.user?.client
        ),
        'user.id'
      );

      mentionIds.push(...projectPerformersId);
      continue;
    }

    if (id === MentionsPluginAllValues.ALL_TASK_MEMBERS) {
      const taskMembersId = map(
        filter(taskMembers, (member) => !member?.user?.blocked),
        'user.id'
      );

      mentionIds.push(...taskMembersId);
      continue;
    }

    if (id === MentionsPluginAllValues.ALL_TASK_PERFORMERS) {
      const taskPerformersId = map(
        filter(
          taskMembers,
          (member) => !member?.user?.blocked && !member?.user?.client
        ),
        'user.id'
      );

      mentionIds.push(...taskPerformersId);
      continue;
    }

    mentionIds.push(id);
  }

  return uniq(mentionIds);
}

export default getMentionIds;
